export default __webpack_public_path__ + "static/media/H_wdt_c_cap_4.6d49a088.mp3";